// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class EnrollmentRequestModel {
    static getAttributeTypeMap() {
        return EnrollmentRequestModel.attributeTypeMap;
    }
}
EnrollmentRequestModel.discriminator = undefined;
EnrollmentRequestModel.attributeTypeMap = [
    {
        "name": "survey",
        "baseName": "survey",
        "type": "Array<EnrollmentSurveyQuestionModel>"
    },
    {
        "name": "demographics",
        "baseName": "demographics",
        "type": "EnrollmentDemographicsModel"
    },
    {
        "name": "clientIdentifiers",
        "baseName": "clientIdentifiers",
        "type": "EnrollmentClientIdentifiersModel"
    }
];
//# sourceMappingURL=enrollmentRequestModel.js.map